export const appSettingsApiKeyDetailsApiKey = "/app_settings/api_key_details/:api_key";
